import type { PointXYZ } from "@lpviz/math/types";

export const DEFAULT_VIEW_ANGLE: PointXYZ = { x: -1.15, y: 0.4, z: 0 };
export const DEFAULT_Z_SCALE = 0.1;
